/**
 * Hook to manage auto-reconnect/error displays for live views
 */
const SocketDisconnect = {
  mounted() {
    this.disconnectedSelector = this.el.dataset.disconnectedSelector;
    this.connectedSelector = this.el.dataset.connectedSelector;
    this.timeout = parseInt(this.el.dataset.timeout || "30") * 1_000;
    this.checkInterval = parseInt(this.el.dataset.checkInterval || "5") * 1_000;
  },

  disconnected() {
    this.disconnectedTimer = window.setTimeout(
      this.startDisconnected.bind(this),
      this.timeout,
    );
  },

  reconnected() {
    if (this.disconnectedTimer) {
      window.clearTimeout(this.disconnectedTimer);
      this.disconnectedTimer = null;
    }

    if (this.checkTimer) {
      window.clearTimeout(this.checkTimer);
      this.checkTimer = null;
    }

    document.querySelector(this.connectedSelector).classList.remove("hidden");
    document.querySelector(this.disconnectedSelector).classList.add("hidden");
  },

  startDisconnected() {
    if (window.SentryClient) {
      window.SentryClient.captureMessage(
        "SocketDisconnect startDisconnected() triggered",
      );
    }

    this.disconnectedTimer = null;

    document.querySelector(this.connectedSelector).classList.add("hidden");
    document
      .querySelector(this.disconnectedSelector)
      .classList.remove("hidden");

    this.checkTimer = window.setTimeout(
      this.checkConnection.bind(this),
      this.checkInterval,
    );
  },

  checkConnection() {
    const req = new XMLHttpRequest();
    try {
      req.open("GET", "/system/healthz", true);
      req.onreadystatechange = () => {
        if (req.readyState == 4) {
          if (req.status == 200) {
            window.setTimeout(() => location.reload(), 5_000);
          } else {
            this.checkTimer = window.setTimeout(
              this.checkConnection.bind(this),
              this.checkInterval,
            );
          }
        }
      };
      req.send();
    } catch (error) {}
  },
};

export default SocketDisconnect;
